import React, { useState, useEffect } from 'react';

const MINT = '#36bba5';
const NAVY = '#17264b';
const COOKIE_NAME = 'cookie-close';
const COOKIE_EXPIRY_DAYS = 7;

// Helper to get a cookie by name
const getCookie = (name) => {
  const dc = document.cookie;
  const prefix = name + '=';
  let begin = dc.indexOf('; ' + prefix);
  if (begin === -1) {
    begin = dc.indexOf(prefix);
    if (begin !== 0) return null;
  } else {
    begin += 2;
  }
  let end = dc.indexOf(';', begin);
  if (end === -1) {
    end = dc.length;
  }
  return decodeURIComponent(dc.substring(begin + prefix.length, end));
};

// Helper to set a cookie
const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = '; expires=' + date.toUTCString();
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

const CookieBanner = ({
  message = 'Global Guardians uses cookies to ensure you get the best experience on our website.',
  learnMoreUrl = 'https://www.global-guardians.co.uk/cookies',
  onClose
}) => {
  // Check if cookie consent was already given
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Only show banner if user hasn't closed it before
    if (!getCookie(COOKIE_NAME)) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const handleClose = () => {
    // Set cookie to remember user's choice (expires in 7 days like Laravel)
    setCookie(COOKIE_NAME, 'true', COOKIE_EXPIRY_DAYS);
    setVisible(false);
    if (onClose) onClose();
  };

  return (
    <div className="footer-cookie-banner" style={{
      position: 'fixed',
      left: 0,
      bottom: 0,
      width: '100%',
      background: '#fff',
      color: NAVY,
      fontWeight: 700,
      fontSize: 18,
      fontFamily: 'Montserrat, Arial, sans-serif',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 -2px 8px rgba(0,0,0,0.05)',
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      zIndex: 1000,
      minHeight: 56,
    }}>
      <span style={{ margin: '0 16px' }}>{message}</span>
      <button
        style={{
          background: MINT,
          color: '#fff',
          fontWeight: 700,
          border: 'none',
          borderRadius: 4,
          padding: '8px 18px',
          margin: '0 8px',
          fontSize: 16,
          cursor: 'pointer',
          letterSpacing: 1,
          fontFamily: 'Montserrat, Arial, sans-serif',
        }}
        onClick={() => window.open(learnMoreUrl, '_blank')}
      >
        + LEARN MORE
      </button>
      <button
        style={{
          background: MINT,
          color: '#fff',
          border: 'none',
          borderRadius: '50%',
          width: 32,
          height: 32,
          fontSize: 20,
          margin: '0 12px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'Montserrat, Arial, sans-serif',
        }}
        onClick={handleClose}
        aria-label="Close cookie banner"
      >
        ×
      </button>
    </div>
  );
};

export default CookieBanner; 